module.exports = __webpack_public_path__ + "assets/3567537387d31adcf75ef1a288cffb05.mp3";